import { render } from "./SegmentInput.vue?vue&type=template&id=2b94b3fd"
import script from "./SegmentInput.vue?vue&type=script&lang=js"
export * from "./SegmentInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__